import React from "react";
import { FaCheck } from "react-icons/fa";
import classNames from "classnames";

// components
import Link from "@/components/Link";

// assets
import styles from "@/assets/styles/containers/getting-started/getting-started-step.module.scss";


interface IGettingStartedStep {
  title: string;
  label: string;
  onLearnMore: () => void;
  active?: boolean;
  pass?: boolean;
  stepKey?: string;
}

function GettingStartedStep({ pass, active, title, label, stepKey, onLearnMore }: IGettingStartedStep) {
  const isCreateAccountStep = stepKey === "create-account";

  const className = classNames(styles["locl-getting-started-step"], {
    [styles["locl-getting-started-step_active"]]: active,
    [styles["locl-getting-started-step_pass"]]: pass,
    [styles["locl-getting-started-step_hide-info"]]: pass && isCreateAccountStep
  });

  return (
    <div className={className} data-testid="locl-getting-started-step">
      <span className={styles["locl-getting-started-step__inner"]}>
        <FaCheck className={styles["locl-getting-started-step__check-icon"]}/>
      </span>
      <h4 className={styles["locl-getting-started-step__title"]}>{ title }</h4>
      <span className={styles["locl-getting-started-step__label"]}>{ label }</span>
      {
        isCreateAccountStep
          ? (
            <Link href="/registration" className={styles["locl-getting-started-step__action-button"]}>
              Sign up
            </Link>
          )
          : (
            <button
              className={styles["locl-getting-started-step__action-button"]}
              onClick={() => onLearnMore()}
              data-testid="locl-getting-started-step-action-button"
            >
              Learn how
            </button>
          )
      }
    </div>
  );
}

export default GettingStartedStep;

